import React from 'react'

/**
 * Flag component using flag-icons library
 * Converts 2 or 3-letter country codes to ISO 3166-1 alpha-2 format
 */

// Mapping for common 3-letter codes to 2-letter ISO codes
const COUNTRY_CODE_MAP = {
  'AUT': 'at', 'GER': 'de', 'SUI': 'ch', 'NOR': 'no', 'POL': 'pl',
  'SLO': 'si', 'JPN': 'jp', 'FRA': 'fr', 'ITA': 'it', 'CZE': 'cz',
  'FIN': 'fi', 'SWE': 'se', 'USA': 'us', 'CAN': 'ca', 'RUS': 'ru',
  'KOR': 'kr', 'CHN': 'cn', 'GBR': 'gb', 'EST': 'ee', 'LAT': 'lv',
  'NED': 'nl', 'ROM': 'ro', 'ROU': 'ro', 'SRB': 'rs', 'UKR': 'ua', 'BUL': 'bg',
  'CRO': 'hr', 'SVK': 'sk', 'ESP': 'es', 'KAZ': 'kz', 'BLR': 'by',
  'LIE': 'li', 'TUR': 'tr', 'GRE': 'gr', 'AUS': 'au', 'NZL': 'nz',
  'BRA': 'br', 'ARG': 'ar', 'CHI': 'cl', 'MEX': 'mx', 'ISR': 'il',
  'RSA': 'za', 'IND': 'in', 'DEN': 'dk', 'BEL': 'be', 'POR': 'pt',
  'HUN': 'hu', 'LTU': 'lt', 'MDA': 'md', 'GEO': 'ge', 'ARM': 'am',
  'MNE': 'me', 'MKD': 'mk', 'BIH': 'ba', 'ALB': 'al', 'ISL': 'is',
}

export default function Flag({ code, size = '1x', className = '', squared = false, ...props }) {
  if (!code) return null
  
  // Convert to lowercase and handle 3-letter codes
  const countryCode = code.length === 3 
    ? COUNTRY_CODE_MAP[code.toUpperCase()] || code.toLowerCase()
    : code.toLowerCase()
  
  const sizeClass = size === '1x' ? '' : `fi-${size}`
  const shapeClass = squared ? 'fis' : 'fi'
  
  return (
    <span
      className={`${shapeClass} fi-${countryCode} ${sizeClass} ${className}`.trim()}
      title={code.toUpperCase()}
      role="img"
      aria-label={code.toUpperCase()}
      {...props}
    />
  )
}
